import React from 'react';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';

const Pagination = ({ currentPage, totalPages, onPageChange, totalItems, itemsPerPage = 10 }) => {
  const maxPageButtons = 5;

  const getPageRange = () => {
    let startPage = currentPage;
    if (currentPage > totalPages - maxPageButtons + 1) {
      startPage = Math.max(1, totalPages - maxPageButtons + 1);
    }
    const endPage = Math.min(startPage + maxPageButtons - 1, totalPages);
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="flex items-center justify-end px-6 py-4">
      <span className="text-gray-400 text-sm m-10">
        Showing {startItem} to {endItem} of {totalItems} results
      </span>
      <div className="flex items-center space-x-2">
        <button
          className="p-2 rounded-full border border-gray-600 text-gray-400 hover:bg-gray-700/50 disabled:opacity-50"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronsLeft className="w-4 h-4 border border-[#D9D9D9] rounded-md" />
        </button>
        {getPageRange().map((page) => (
          <button
            key={page}
            className={`w-8 h-8 rounded-full text-sm font-medium ${
              page === currentPage
                ? "text-[#D9D9D9] bg-gradient-to-r from-[#FF60B6] to-[#2960FD]"
                : "border border-gray-600 text-gray-400 hover:bg-gray-700/50"
            }`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}
        {totalPages > maxPageButtons && currentPage < totalPages - maxPageButtons + 1 && (
          <span className="text-gray-400 px-2">...</span>
        )}
        {totalPages > maxPageButtons && currentPage < totalPages - maxPageButtons + 1 && (
          <button
            className="w-8 h-8 rounded-full border border-gray-600 text-gray-400 hover:bg-gray-700/50 text-sm"
            onClick={() => onPageChange(totalPages)}
          >
            {totalPages}
          </button>
        )}
        <button
          className="p-2 rounded-full border border-gray-600 text-gray-400 hover:bg-gray-700/50 disabled:opacity-50"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <ChevronsRight className="w-4 h-4 border border-[#D9D9D9] rounded-md" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
